<template>
  <div class="resetPassword container h-100">
    <div class="content">
      <div style="border-bottom: #F2F2F2 1px solid;margin-bottom: 8px">
        <h2 style="color:red;text-align:left;">安全设置</h2>
      </div>

      <div style="width: clamp(600px,40%,1024px);border: #F2F2F2 1px solid;padding: 30px;border-radius: 8px">
        <el-form :model="userForm" class="userForm" ref="refUserForm" :rules="rules" label-width="100px"
                 label-position="right" label-suffix="：" @submit.native.prevent>
          <el-form-item label="当前密码" prop="old_pass">
            <el-input v-model="userForm.old_pass" placeholder="请输入旧密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input v-model="userForm.password" placeholder="请输入新密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirm_pass">
            <el-input v-model="userForm.confirm_pass" placeholder="请输入确认密码" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleChangePassword" :loading="loadingSubmit" :disabled="loadingSubmit">
              {{ loadingSubmit ? '提交中...' : '修改密码' }}
            </el-button>

            <el-tooltip
                class="item" effect="dark" content="推荐一个密码，长度：12位，包含大小写字母和数字"
                placement="top-start"
            >
              <el-button type="warning" @click="makePassword">生成密码</el-button>
            </el-tooltip>

            <el-button icon="el-icon-document-copy" @click="handleCopy">复制</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import {changePassword} from "@/api/user";
import {copyToClipboard, generatePassword, validatePassword} from "@/utils/security";

export default {
  name: 'updatePassword',
  data() {
    let validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        // 验证密码规则
        const passwordValidation = validatePassword(value)
        if (!passwordValidation.valid) {
          callback(new Error(passwordValidation.message))
          return
        }
        if (this.userForm.confirm_pass !== '') {
          this.$refs.refUserForm.validateField('confirm_pass');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loadingSubmit: false,
      userForm: {
        old_pass: '',
        password: '',
        confirm_pass: '',
      },
      rules: {
        old_pass: [
          {required: true, message: '密码不能为空', trigger: 'blur'},
        ],
        password: [
          {required: true, validator: validatePass1, trigger: 'blur'},
        ],
        confirm_pass: [
          {required: true, validator: validatePass2, trigger: 'blur'},
        ],
      }

    }
  },
  methods: {
    handleChangePassword() {
      this.$refs['refUserForm'].validate((valid) => {
            if (valid) {
              this.loadingSubmit = true
              let data = this.userForm;
              // eslint-disable-next-line
              changePassword(data).then(res => {
                setTimeout(() => {
                  this.loadingSubmit = false
                }, 2000)
                if (res.success) {
                  this.$ls.clear()
                  this.$alert('密码修改成功，将返回登录页面重新登录', '修改密码', {
                    confirmButtonText: '确定',
                    callback: action => {
                      // this.$message({
                      //   type: 'info',
                      //   message: `action: ${ action }`
                      // });
                      if (action === 'confirm') {

                        this.$router.push({path: '/login'})
                      }

                    }
                  });
                }

                // this.$ls.clear()
                // this.$router.push({path: '/login'})
                // this.$ls.clear()
              })
            }
      })

    },
    // 生成密码：推荐规则-长度12位，包含大小写字母和数字
    makePassword() {
      const password = generatePassword(12, ['uppercase', 'lowercase', 'numbers'])
      this.userForm.password = password
      this.userForm.confirm_pass = password
    },
    handleCopy() {
      if (this.userForm.password) {
        copyToClipboard(this.userForm.password)
        this.$message.success('已复制到剪贴板')
      } else {
        this.$notify.warning('未输入新密码')
      }

    }
  }
}
</script>

<style scoped>
.resetPassword {
  /*margin-top: 70px;*/
}

.content {
  background: #fff;
  padding: 24px 30px 0 30px;
}
</style>
<style>
input {
  background: transparent;
}

input:-webkit-autofill {
  -webkit-text-fill-color: #606266 !important;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
</style>
